import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import CUSTOMER_QUERY from './graph';
import Account from '../index';

const AccountWithGQL = ({ customerToken, handleLogout }) => {
  const token = customerToken ? JSON.parse(customerToken) : null;
  const { loading, error, data, refetch } = useQuery(CUSTOMER_QUERY, {
    variables: { customerAccessToken: token.accessToken },
  });
  return (
    <Account
      customer={data && data.customer ? data.customer : null}
      token={token.accessToken}
      error={error}
      loading={loading}
      handleLogout={handleLogout}
      refetch={refetch}
    />
  );
};

AccountWithGQL.propTypes = {
  customerToken: PropTypes.string,
  handleLogout: PropTypes.func,
};

AccountWithGQL.defaultProps = {
  customerToken: null,
  handleLogout: null,
};

export default AccountWithGQL;
